import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Col, Image, Row, Typography } from 'antd';

import { ActionButton } from '@hdi-seguros/web-components.action-button';

import { QuotationInfoContext } from '../../contexts';

import { QuotationDoneIcon } from '../../../../../../../assets';

import { COLORS } from '../../../../../../../config/themes/colors';

export const ConfirmIssue = () => {
  const navigate = useNavigate();

  const { quotationInfo } = useContext(QuotationInfoContext);

  const onPressConfirm = () => navigate('/produccion/listado-de-polizas');

  return (
    <Row style={{ width: '100%', rowGap: 10 }} align='middle' justify='center'>
      <Col span={24} style={{ textAlign: 'center' }}>
        <Image
          src={QuotationDoneIcon}
          width={250}
          height={200}
          preview={false}
        />
      </Col>

      <Col span={24} style={{ textAlign: 'center' }}>
        <Typography.Title level={3} style={{ color: COLORS.neutrals[80] }}>
          Cotización {quotationInfo?.token} enviada correctamente
        </Typography.Title>
      </Col>

      <Col xs={{ span: 24 }} sm={{ span: 8 }} style={{ textAlign: 'center' }}>
        <Typography.Text type='secondary' style={{ fontSize: 20 }}>
          Se ha enviado un correo electrónico con la información de la propuesta{' '}
          {quotationInfo?.proposalNumber} a la casilla del productor.
        </Typography.Text>
      </Col>

      <Col span={24} style={{ textAlign: 'center' }}>
        <ActionButton
          label='Aceptar'
          style={{ width: 140 }}
          onClick={onPressConfirm}
        />
      </Col>
    </Row>
  );
};
